import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/sharedFeatures/services/language';
import { UserService } from 'src/app/modules/users/services/user.service';
import { UserLoggedIn } from 'src/app/sharedFeatures/models/user-login.model';
import { CurrentUserService } from '../../../../../sharedFeatures/services/current-user.service';

import { NotificationService } from 'src/app/sharedFeatures/services/notification.service';
import { EventEmitterService } from 'src/app/sharedFeatures/services/EventEmitterService';
import * as bootstrap from 'bootstrap';
import { NotificationDetailsService } from 'src/app/modules/Notification/Services/NotificationDetails.service';
import { NotificationsService } from 'src/app/modules/Notification/Services/Notifications.service';
import { NotificationSearchModel } from 'src/app/modules/Notification/Models/Notification-search-model.model';
import { catchError, filter, of } from 'rxjs';
import { AiChatService } from '../../../../../modules/ai-assistant/services/ai-chat.service';
import { TreeNode } from '../../../../../sharedFeatures/models/Dropdown-item';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MilestoneTaskDetailsComponent } from '../../../../../modules/project/components/milestone-task-details/milestone-task-details.component';
import { ActionPlanService } from '../../../../../modules/MSM_CheckListFront/ActionPlan/services/action-plan.service';
import { ActionPlanFilter } from '../../../../../modules/MSM_CheckListFront/ActionPlan/models/action-plan.model';
import { UmRole } from '../../../../../modules/roles/models/role-enum';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
  nodes: TreeNode[] = [];
  selectedNode: TreeNode;
  lang: string = 'ar';
  currentUser: UserLoggedIn | null = null;
  domainUrl: string;
  currentDate: Date = new Date();
  searchModel: NotificationSearchModel = new NotificationSearchModel();
  ref: DynamicDialogRef | undefined;
  isPhead: boolean = false;
  isPAdmin: boolean = false;

  // Flag to track if token exchange is complete and API calls are safe
  private isTokenReady: boolean = false;
  // Master switch for the nav-bar notification + reports features.
  // Set to true to bring the nav-bar notification/report pills back (also un-comment the markup in nav-bar.component.html).
  private readonly notificationsEnabled: boolean = false;

  /*   languagesList = [
    {
      label: 'العربية',
      command: () => {
        this.changeLang('ar');
      },
    },
    {
      label: 'English',
      command: () => {
        this.changeLang('en');
      },
    },
  ]; */
  /** Set only when the API confirms the AiAssistant.Use privilege. Drives the assistant icon. */
  canUseAssistant: boolean = false;

  constructor(
    private currentUserService: CurrentUserService,
    private router: Router,

    private notificationService: NotificationService,
    private _eventEmitterService: EventEmitterService,
    private _UsersService: UserService,
    private translateService: TranslateService,
    public languageService: LanguageService,
    private _NotificationsService: NotificationsService,
    private _NotificationDetailsService: NotificationDetailsService,
    private cdr: ChangeDetectorRef,
    public dialogService: DialogService,
    private _ActionPlanService: ActionPlanService,
    private _aiChatService: AiChatService
  ) {
    this._eventEmitterService.onReloadNotifications.subscribe(res => {
      // Only call API if token is ready
      if (this.isTokenReady) {
        this.getCountUnSeenNotifications();
      }
    });
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        // Only call API if token is ready
        if (this.isTokenReady) {
          this.getCountUnSeenNotifications(); // Call the method on route change

          // Also refresh reports count on route change for Project Heads and Project Admins
          if (this.isPhead || this.isPAdmin) {
            this.getActionPlanReports();
          }
        }
      });
    this.domainUrl = this._UsersService.domainUrl;
  }

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
    ////;
    this.currentUser = this.currentUserService.getCurrentUser();

    // Validate user session - redirect to module selection if roleName is missing
    if (!this.isValidUserSession(this.currentUser)) {
      this.router.navigate(['/modules']);
      return;
    }

    // Set role flags using roleId instead of magic strings
    this.isPhead = this.currentUser?.roleId === UmRole.ProjectHead;
    this.isPAdmin = this.currentUser?.roleId === UmRole.ProjectAdmin;

    // Initialize search model with userId for ChecklistFlow API
    this.searchModel.userId = this.currentUser?.id?.toString() || null;
    this.searchModel.count = 50; // Get more notifications

    // Wait for token exchange to complete before making API calls
    // This prevents 401 errors when token is not yet available
    this.currentUserService
      .isTokenExchangeCompleted()
      .subscribe(isExchanged => {
        if (isExchanged) {
          // Mark token as ready for other subscriptions (router events, event emitter)
          this.isTokenReady = true;

          // Re-get current user after token exchange is confirmed
          this.currentUser = this.currentUserService.getCurrentUser();

          // Validate user session after token exchange - redirect to module selection if roleName is missing
          if (!this.isValidUserSession(this.currentUser)) {
            this.router.navigate(['/modules']);
            return;
          }

          this.isPhead = this.currentUser?.roleId === UmRole.ProjectHead;
          this.isPAdmin = this.currentUser?.roleId === UmRole.ProjectAdmin;
          this.searchModel.userId = this.currentUser?.id?.toString() || null;

          this.getNotificationsByUserId();
          this.getCountUnSeenNotifications();
          this.checkAiAssistantPrivilege();

          // Only load reports for Project Heads and Project Admins
          if (this.isPhead || this.isPAdmin) {
            this.getActionPlanReports();
          }
        } else {
          // Token not ready, reset flag
          this.isTokenReady = false;
          this.canUseAssistant = false;
        }
      });
    // //;
    //this.loadSectionsFromLocalStorage();
  }
  // loadSectionsFromLocalStorage(): void {
  //   const localStorageKeys = ['sections', 'projects', 'milestones', 'tasks'];

  //   const createNode = (data: any[], labelKey: string, keyPrefix: string): TreeNode[] =>
  //     data.map((item, index) => ({
  //       label: item[labelKey],
  //       key: `${keyPrefix}-${item.id}`,
  //     }));

  //   // Load data from local storage and build the tree structure
  //   for (const key of localStorageKeys) {
  //     const storedData = localStorage.getItem(key);

  //     if (storedData) {
  //       const parsedData = JSON.parse(storedData);
  //       this.nodes.push({
  //         label: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize key
  //         key: key,
  //         children: createNode(parsedData, 'name', key), // Use 'name' as the label for each child
  //       });
  //     } else {
  //       console.error(`No ${key} found in local storage.`);
  //     }
  //   }

  //   console.log(this.nodes);
  // }

  // onNodeSelect(event: any): void {
  //   const selectedNode = event.node; // Get the selected node
  //   const [category, id] = selectedNode.key.split('-'); // Extract the key and ID

  //   console.log('Category:', category);
  //   console.log('Selected ID:', id);

  //   switch (category) {
  //     case 'sections':
  //       this.router.navigate([`/section/view/`, id]);
  //       break;

  //     case 'projects':
  //       this.router.navigate(['/project/edit', id]);
  //       break;

  //     case 'milestones':
  //       this.router.navigate(['/milestone/list/' + id]);
  //       break;

  //     case 'tasks':
  //       this.onTaskClick(id);
  //       break;

  //     default:
  //       console.error('Unknown category:', category);
  //       break;
  //   }

  //   // Perform actions based on the selected category and ID
  // }
  // onTaskClick(taskId: number): void {
  //   this.ref = this.dialogService.open(MilestoneTaskDetailsComponent, {
  //     width: 'calc(100vw - 200px)',
  //     height: 'calc(100vh - 100px)',
  //     closable: false,
  //     styleClass: 'dct-task-details',
  //     data: {
  //       taskId,
  //     },
  //   });
  // }

  DismissNotificationMinue() {
    document.querySelector('#content')!.addEventListener('click', event => {
      const notificationCard: any = document.querySelector('#notificationCard');
      const withinBoundaries = event.composedPath().includes(notificationCard);
      if (withinBoundaries) {
        notificationCard.style.top = '71px';
      } else {
        notificationCard.style.top = '-150%';
        document
          .querySelector('.active-notification')
          ?.classList.remove('active-notification');
      }
    });
  }
  addActiveNotification(el: HTMLElement) {
    /*     const notificationCard: HTMLElement =
          document.querySelector('#notificationCard')!; */
    this.seenAllNotification();
  }
  seenAllNotification() {
    if (!this.notificationsEnabled) return;
    this.getNotificationsByUserId();
    this._NotificationDetailsService.UpdateSeen().subscribe(
      (res: any) => {
        let x = res;
        this.getCountUnSeenNotifications();
      },
      (error: any) => {
        // this.notificationService.showErrorTranslated(
        //   'error.shared.operationFailed',
        //   error
        // );
      },
      () => {}
    );
  }
  seenNotification(notification: any) {
    this.isOpenMessage = true;
    this._NotificationDetailsService
      .seenNotificationByUserAsync(this.currentUser?.id, notification.id)
      .subscribe(
        (res: any) => {
          let x = res;
          this.getNotificationsByUserId();
          this.getCountUnSeenNotifications();

          this.goToLink(notification.url);
          this.isOpenMessage = false;
        },
        (error: any) => {
          // this.notificationService.showErrorTranslated(
          //   'error.shared.operationFailed',
          //   error
          // );
        },
        () => {}
      );
  }

  getNotificationsByUserId() {
    // DISABLED: notifications pill is commented out in the template - skip the API call.
    if (!this.notificationsEnabled) return;
    this._NotificationsService.search(this.searchModel).subscribe(
      (res: any) => {
        if (this.pageIndex == 0) this.notifications = res;
        else {
          this.notifications.collection!.push(...res.collection!);
          this.notifications.pagination = res.pagination;
        }
      },
      (error: any) => {
        // this.notificationService.showErrorTranslated(
        //   'error.shared.operationFailed',
        //   error
        // );
      },
      () => {}
    );
  }
  getCountUnSeenNotifications() {
    // DISABLED: notifications pill is commented out in the template - skip the API call.
    if (!this.notificationsEnabled) return;
    let userId = this.currentUser?.id;

    this._NotificationDetailsService
      .getCountUnSeenNotifications(userId)
      .subscribe(
        (res: number) => {
          this.UnSeenNotifications = res;
          this.cdr.detectChanges(); // Trigger manual change detection
        },
        (error: any) => {
          // this.notificationService.showErrorTranslated(
          //   'error.shared.operationFailed',
          //   error
          // );
        },
        () => {}
      );
  }

  onScrollDown(s: any) {
    if (
      this.notifications.collection!.length <
      this.notifications!.pagination!.totalCount!
    ) {
      this.pageIndex = this.pageIndex + 1;
      // this.getNotificationsByUserId();
    }
  }

  goToLink(url: string) {
    if (url != null) {
      if (url?.includes('http')) {
        window.open(url, '_blank');
      } else {
        this.router.navigate([url]);
      }
    }
  }

  userLogout() {
    this.currentUserService.logOut();
    // this.router.navigate(['/login']);
  }
  openLogOut() {
    const modalElement = document.getElementById('logOutModel');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
  viewUser() {
    let url = '/users/view/' + this.currentUser?.id + '/1';
    this.router.navigate([url]);
  }

  // Navigate to Change Password page
  navigateToChangePassword(): void {
    // Use simple route without parameters for self-service password change
    this.router.navigate(['/users/change-password']);
  }

  /**
   * Organization logo shown on the left of the nav bar — Stakeholder users
   * only. Only their uploaded logo (`logoPath`, a full Azure Blob URL) is
   * shown; if they haven't uploaded one, the slot stays hidden. Empty for
   * non-Stakeholder users too.
   */
  get organizationLogoUrl(): string {
    if (this.currentUser?.roleId !== UmRole.Stakeholder) {
      return '';
    }
    const logo = this.currentUser?.logoPath;
    return logo && logo.trim() ? logo : '';
  }

  // Check if user can change password (not Active Directory user)
  get canChangePassword(): boolean {
    // If isActiveDirectoryUser property exists and is true, cannot change password
    return this.currentUser?.isActiveDirectoryUser !== true;
  }

  changeLang(lang: string) {
    this.translateService.use(lang);
    localStorage.setItem('currentLang', lang);

    this.languageService.setLanguage(lang);
  }
  isOpenMessage: boolean = false;

  UnSeenNotifications: number = 0;
  pageIndex = 0;
  pageSize = 20;
  notifications: any;
  reportsCount: number = 0;
  reports: any[] = [];

  getActionPlanReports() {
    // DISABLED: reports pill is commented out in the template - skip the API call.
    if (!this.notificationsEnabled) return;
    // Use CheckListActionPlanFilterationDTO format (same as original MVC version)
    // Different payload for Project Admin vs Project Head
    const payload: any = {
      PageNumber: 1,
      PageSize: 10000,
      PendingStatus: true,
      Include: false,
    };

    if (this.isPhead) {
      payload.IsPhead = true;
    } else if (this.isPAdmin) {
      payload.UserId = this.currentUser?.id;
    }

    // Call the API directly with the correct endpoint
    const url = `${this._ActionPlanService['mysteryShopperUrl'].replace('/api', '/Api')}/ActionPlanMasterAPI/GetActionPlanMasterListView`;

    this._ActionPlanService['postData']<any>(url, payload).subscribe(
      (res: any) => {
        if (res && Array.isArray(res)) {
          this.reports = res;
          this.reportsCount = res.length;
          this.cdr.detectChanges();
        }
      },
      (error: any) => {
        // this.notificationService.showErrorTranslated(
        //   'error.shared.operationFailed',
        //   error
        // );
      }
    );
  }

  /**
   * Validates that the user session has required data
   * Returns false if roleName is empty or null (requires module/role selection)
   */
  private isValidUserSession(user: UserLoggedIn | null): boolean {
    if (!user) {
      return false;
    }
    // Check if roleName exists and is not empty
    if (!user.roleName || user.roleName.trim() === '') {
      return false;
    }
    return true;
  }

  /**
   * Decides whether the AI assistant icon is shown.
   *
   * The AiAssistant.Use privilege (B1F4C2D0-8E6A-4C31-9F77-2A5D1E93C401) is not carried in the
   * JWT — the `permissions` claim holds integer permission codes, not privilege GUIDs — so the
   * API is the only authority on it. Api/AiChat/Capabilities is decorated with
   * [RequireAiPrivilege(AiAssistant.Use)] and answers 403 without the privilege, so a successful
   * response is the grant. Any failure hides the icon: default-deny, matching the API.
   */
  private checkAiAssistantPrivilege(): void {
    this._aiChatService
      .getCapabilities()
      .pipe(catchError(() => of(null)))
      .subscribe(capabilities => {
        this.canUseAssistant = capabilities !== null;
      });
  }
}
